module.exports = __webpack_public_path__ + "6a6f6b4e43efd4cf3f9dc507efaccff6.MP3";